export const uniswapFeeHandlerSellerABI = [
    {
        payable: false,
        stateMutability: 'nonpayable',
        type: 'constructor',
        inputs: [{ name: 'test', internalType: 'bool', type: 'bool' }],
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'tokenAddress', internalType: 'address', type: 'address', indexed: false },
            { name: 'minimumReports', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'MinimumReportsSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: '_token', internalType: 'address', type: 'address', indexed: false },
            { name: '_oracle', internalType: 'address', type: 'address', indexed: false },
        ],
        name: 'OracleAddressSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'previousOwner', internalType: 'address', type: 'address', indexed: true },
            { name: 'newOwner', internalType: 'address', type: 'address', indexed: true },
        ],
        name: 'OwnershipTransferred',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'tokneAddress', internalType: 'address', type: 'address', indexed: true },
            { name: 'router', internalType: 'address', type: 'address', indexed: true },
            { name: 'quote', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ReceivedQuote',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'registryAddress', internalType: 'address', type: 'address', indexed: true }],
        name: 'RegistrySet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'token', internalType: 'address', type: 'address', indexed: false },
            { name: 'router', internalType: 'address', type: 'address', indexed: false },
        ],
        name: 'RouterAddressRemoved',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'token', internalType: 'address', type: 'address', indexed: false },
            { name: 'router', internalType: 'address', type: 'address', indexed: false },
        ],
        name: 'RouterAddressSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'router', internalType: 'address', type: 'address', indexed: false }],
        name: 'RouterUsed',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'soldTokenAddress', internalType: 'address', type: 'address', indexed: false },
            { name: 'boughtTokenAddress', internalType: 'address', type: 'address', indexed: false },
            { name: 'amount', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'TokenSold',
    },
    { payable: true, stateMutability: 'payable', type: 'fallback' },
    {
        constant: true,
        payable: false,
        stateMutability: 'pure',
        type: 'function',
        inputs: [
            { name: 'midPriceNumerator', internalType: 'uint256', type: 'uint256' },
            { name: 'midPriceDenominator', internalType: 'uint256', type: 'uint256' },
            { name: 'amount', internalType: 'uint256', type: 'uint256' },
            { name: 'maxSlippage', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'calculateMinAmount',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '_tokenAddress', internalType: 'address', type: 'address' }],
        name: 'getOracleAddress',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: '_registryAddress', internalType: 'address', type: 'address' },
            { name: 'tokenAddresses', internalType: 'address[]', type: 'address[]' },
            { name: 'newMininumReports', internalType: 'uint256[]', type: 'uint256[]' },
        ],
        name: 'initialize',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'initialized',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'isOwner',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'address', type: 'address' }],
        name: 'minimumReports',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'address', type: 'address' }],
        name: 'oracleAddresses',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'owner',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'registry',
        outputs: [{ name: '', internalType: 'contract IRegistry', type: 'address' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'tokenAddress', internalType: 'address', type: 'address' },
            { name: 'newMininumReports', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'setMinimumReports',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: '_tokenAddress', internalType: 'address', type: 'address' },
            { name: '_oracleAddress', internalType: 'address', type: 'address' },
        ],
        name: 'setOracleAddress',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'registryAddress', internalType: 'address', type: 'address' }],
        name: 'setRegistry',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'token', internalType: 'address', type: 'address' },
            { name: 'amount', internalType: 'uint256', type: 'uint256' },
            { name: 'to', internalType: 'address', type: 'address' },
        ],
        name: 'transfer',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'token', internalType: 'address', type: 'address' },
            { name: 'router', internalType: 'address', type: 'address' },
        ],
        name: 'setRouter',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'token', internalType: 'address', type: 'address' },
            { name: 'router', internalType: 'address', type: 'address' },
        ],
        name: 'removeRouter',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'sellTokenAddress', internalType: 'address', type: 'address' },
            { name: 'buyTokenAddress', internalType: 'address', type: 'address' },
            { name: 'amount', internalType: 'uint256', type: 'uint256' },
            { name: 'maxSlippage', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'sell',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'token', internalType: 'address', type: 'address' }],
        name: 'getRoutersForToken',
        outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'pure',
        type: 'function',
        inputs: [],
        name: 'getVersionNumber',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
];
